import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%"
  },
  class: "exam-list"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "text-align": "center",
    "width": "100%",
    "margin-top": "50px",
    "font-size": "20px"
  }
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "exam-title"
}, "甄别计划", -1);
const _hoisted_4 = {
  class: "exam-content"
};
const _hoisted_5 = {
  class: "paper-title-1"
};
const _hoisted_6 = {
  class: "paper-title-2"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-info"
}, "甄别总时长 ", -1);
const _hoisted_8 = {
  class: "paper-info-detail"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-info"
}, "甄别单元数 ", -1);
const _hoisted_10 = {
  class: "paper-info-detail"
};
const _hoisted_11 = {
  class: "paper-title-1"
};
const _hoisted_12 = {
  class: "paper-title-2"
};
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-info"
}, "甄别总时长 ", -1);
const _hoisted_14 = {
  class: "paper-info-detail"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-info"
}, "甄别单元数 ", -1);
const _hoisted_16 = {
  class: "paper-info-detail"
};
const _hoisted_17 = {
  class: "my-header"
};
const _hoisted_18 = {
  class: "review-dialog__rank"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://sjxzc.oss-cn-beijing.aliyuncs.com/2025/07/24/cup.png",
  class: "review-dialog__img",
  alt: ""
}, null, -1);
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-reult"
}, "初试成绩", -1);
const _hoisted_21 = {
  class: "paper-reult-rank"
};
const _hoisted_22 = {
  class: "paper-reult-rank"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-reult-rank"
}, "初试成绩如下，参考正确率为 75% 以上", -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-reult",
  style: {
    "padding-top": "20px"
  }
}, "复试成绩", -1);
const _hoisted_25 = {
  class: "paper-reult-rank"
};
const _hoisted_26 = {
  class: "paper-reult-rank"
};
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "paper-reult-rank"
}, "复试成绩如下，参考正确率为 75% 以上", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.examList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 暂无考试计划 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.examList, (item, index) => {
    return _openBlock(), _createBlock(_component_el_row, {
      key: index,
      class: "exam-container"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 6,
        class: "exam-container-left"
      }, {
        default: _withCtx(() => [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("p", null, [_createTextVNode(" 甄别名称： "), _createElementVNode("span", null, _toDisplayString(item.planName), 1)]), _createElementVNode("p", null, [_createTextVNode(" 甄别编号： "), _createElementVNode("span", null, _toDisplayString(item.assessmentId), 1)]), _createElementVNode("p", null, [_createTextVNode(" 甄别级别： "), _createElementVNode("span", null, _toDisplayString(item.assessmentLevel), 1)]), _createVNode(_component_el_button, {
          class: "exam-result",
          type: "primary",
          size: "large",
          disabled: item?.initialExam?.examStatus !== 'COMPLETED' || item?.retakeExam?.examStatus !== 'COMPLETED',
          onClick: $event => $options.goToResult(item.examPlanId)
        }, {
          default: _withCtx(() => [_createTextVNode("查看考试结果")]),
          _: 2
        }, 1032, ["disabled", "onClick"])])]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 9,
        class: "exam-container-right"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createTextVNode("甄别初试 "), _createVNode(_component_el_tag, {
          type: $options.getExamStatuTag(item?.initialExam?.examStatus),
          effect: "plain",
          round: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getExamStatuLabel(item?.initialExam?.examStatus)), 1)]),
          _: 2
        }, 1032, ["type"])]), _createElementVNode("div", _hoisted_6, _toDisplayString(item?.initialExam?.paperName), 1), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(item?.initialExam?.duration), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item?.initialExam?.units?.length), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_el_button, {
          class: "into-paper",
          size: "large",
          type: "primary",
          disabled: item?.initialExam?.examStatus === 'COMPLETED',
          onClick: $event => $options.goToExam(item.examPlanId, 'INITIAL')
        }, {
          default: _withCtx(() => [_createTextVNode("进入初试")]),
          _: 2
        }, 1032, ["disabled", "onClick"])]),
        _: 2
      }, 1024), _createVNode(_component_el_col, {
        span: 9,
        class: "exam-container-right"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createTextVNode("甄别复试 "), _createVNode(_component_el_tag, {
          type: $options.getExamStatuTag(item?.retakeExam?.examStatus),
          effect: "plain",
          round: ""
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($options.getExamStatuLabel(item?.retakeExam?.examStatus)), 1)]),
          _: 2
        }, 1032, ["type"])]), _createElementVNode("div", _hoisted_12, _toDisplayString(item?.retakeExam?.paperName), 1), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(item?.retakeExam?.duration), 1)]),
            _: 2
          }, 1024), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(item?.retakeExam?.units?.length), 1)]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1024), _createVNode(_component_el_button, {
          class: "into-paper",
          size: "large",
          type: "primary",
          disabled: item?.initialExam?.examStatus !== 'COMPLETED' || item?.retakeExam?.examStatus === 'COMPLETED',
          onClick: $event => $options.goToExam(item.examPlanId, 'RETAKE')
        }, {
          default: _withCtx(() => [_createTextVNode("进入复试")]),
          _: 2
        }, 1032, ["disabled", "onClick"])]),
        _: 2
      }, 1024)]),
      _: 2
    }, 1024);
  }), 128)), $data.dialogVisible ? (_openBlock(), _createBlock(_component_el_dialog, {
    key: 1,
    class: "mock-exam-review-dialog",
    modelValue: $data.dialogVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialogVisible = $event),
    width: "1110",
    title: ""
  }, {
    header: _withCtx(({}) => [_createElementVNode("div", _hoisted_17, [_createVNode(_component_el_row, null, {
      default: _withCtx(() => [_createVNode(_component_el_col, {
        span: 18
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.examResult.planName) + " - 成绩表单", 1)]),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 6
      }, {
        default: _withCtx(() => [_hoisted_19]),
        _: 1
      })]),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", null, [_hoisted_20, _createElementVNode("div", _hoisted_21, "你的排名：" + _toDisplayString($data.rankInfo.initial.rank || '-') + " " + _toDisplayString(" ") + "(参与初试人数：" + _toDisplayString($data.rankInfo.initial.rankUserCnt) + ")", 1), _createElementVNode("div", _hoisted_22, "你的分数：" + _toDisplayString($data.rankInfo.initial.totalScore) + "（考试平均分：" + _toDisplayString($data.rankInfo.initial.allUserAverageScore) + "） ", 1), _hoisted_23, _createVNode(_component_el_table, {
      data: _ctx.examResult.initialUnits,
      style: {
        "width": "100%"
      },
      ref: "table"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "unitOrder",
        label: "单元序号"
      }), _createVNode(_component_el_table_column, {
        prop: "unitName",
        label: "单元题型"
      }), _createVNode(_component_el_table_column, {
        prop: "duration",
        label: "单元时长"
      }), _createVNode(_component_el_table_column, {
        prop: "questionCount",
        label: "题目数量"
      }), _createVNode(_component_el_table_column, {
        prop: "rightAnswers",
        label: "正确数量"
      }), _createVNode(_component_el_table_column, {
        prop: "wrongAnswers",
        label: "错误数量"
      }), _createVNode(_component_el_table_column, {
        prop: "notDo",
        label: "未答数量"
      }), _createVNode(_component_el_table_column, {
        prop: "accuracy",
        label: "正确率"
      })]),
      _: 1
    }, 8, ["data"]), _hoisted_24, _createElementVNode("div", _hoisted_25, "你的排名：" + _toDisplayString($data.rankInfo.retake.rank || '-') + " " + _toDisplayString(" ") + "(参与复试人数：" + _toDisplayString($data.rankInfo.retake.rankUserCnt) + ")", 1), _createElementVNode("div", _hoisted_26, "你的分数：" + _toDisplayString($data.rankInfo.retake.totalScore) + "（考试平均分：" + _toDisplayString($data.rankInfo.retake.allUserAverageScore) + "） ", 1), _hoisted_27, _createVNode(_component_el_table, {
      data: _ctx.examResult.retakeUnits,
      style: {
        "width": "100%"
      },
      ref: "table"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "unitOrder",
        label: "单元序号"
      }), _createVNode(_component_el_table_column, {
        prop: "unitName",
        label: "单元题型"
      }), _createVNode(_component_el_table_column, {
        prop: "duration",
        label: "单元时长"
      }), _createVNode(_component_el_table_column, {
        prop: "questionCount",
        label: "题目数量"
      }), _createVNode(_component_el_table_column, {
        prop: "rightAnswers",
        label: "正确数量"
      }), _createVNode(_component_el_table_column, {
        prop: "wrongAnswers",
        label: "错误数量"
      }), _createVNode(_component_el_table_column, {
        prop: "notDo",
        label: "未答数量"
      }), _createVNode(_component_el_table_column, {
        prop: "accuracy",
        label: "正确率"
      })]),
      _: 1
    }, 8, ["data"])])]),
    _: 1
  }, 8, ["modelValue"])) : _createCommentVNode("", true)]);
}